import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { GetServerSidePropsContext } from "next";

import httpClient from "helpers/hybridHttpClient";

import type { CompleteBlockParams } from "types/courses/block";
import { BLOCK_QUERY_KEY_PREFIX } from "./constants";

const completeBlockByField = async (
  params: CompleteBlockParams,
  ctx?: GetServerSidePropsContext,
) => {
  await httpClient(ctx).post(
    "/api/courses-user-new/block/complete/",
    {},
    {
      params,
    },
  );
};

export const useCompleteBlockByField = (mutationKey: string[] = []) => {
  return useMutation<void, AxiosError, CompleteBlockParams>({
    mutationFn: completeBlockByField,
    mutationKey: [BLOCK_QUERY_KEY_PREFIX, "complete", ...mutationKey],
  });
};

export const generateCompleteBlockByFieldMutationKey = (
  mutationKey: string[],
) => [BLOCK_QUERY_KEY_PREFIX, "complete", ...mutationKey];

useCompleteBlockByField.generateMutationKey =
  generateCompleteBlockByFieldMutationKey;
